function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self1 = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self1, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { LOCK_PERIODS } from "@common/constants";
import { CONTEXT_MATCH_TYPES } from "@common/constants";
import { convertCurrency, getSessionLockTime } from "@common/services/helpers";
import request from "@common/services/request";
import { FIREBASE_CONFIG, MAX_PRICE_PERCENT_DIFFERENCE, TV_BOX_ID_TO_TYPE_MAP } from "@config/constants";
import axios from "axios";
import pointer from "json-pointer";
import { isEmpty, isEqual, isEqualWith, isNil, padStart } from "lodash";
import { COUNTRY_DROPDOWN, FIRST_NAME_INPUT, LAST_NAME_INPUT, PHONE_INPUT, REGEX_ADDRESS, REGEX_ALPHABET, REGEX_ALPHANUMERIC, REGEX_PHONE } from "@config/constants";
var instance = axios.create({
    baseURL: "https://pg-app-ieof9w8wfld2dfgsbdukkddjikzyd3.scalabl.cloud/1"
});
instance.defaults.headers["Content-Type"] = "application/json";
instance.defaults.headers.common["X-Parse-Application-Id"] = "TOeeyWdB8FDS2mqbxr8FCIOOAUiQIBWaGKRLVYaK";
instance.defaults.headers.common["X-Parse-JavaScript-Key"] = "0z0DTyyMlOngHUh5eo64r4xXaIARLKGReOiiBLYk";
var langs = require("langs");
var availableLanguages = langs.all();
export var trace = function(params) {
    instance.post("/classes/errors", params);
};
export var initializeFirebase = function() {
    return new Promise(/*#__PURE__*/ _async_to_generator(function() {
        var initializeApp, getAnalytics, app, analytics, error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        import("firebase/app")
                    ];
                case 1:
                    initializeApp = _state.sent().initializeApp;
                    return [
                        4,
                        import("firebase/analytics")
                    ];
                case 2:
                    getAnalytics = _state.sent().getAnalytics;
                    if (isEmpty(FIREBASE_CONFIG)) {
                        throw new Error("No firebase config provided");
                    }
                    // Initialize Firebase
                    app = initializeApp(FIREBASE_CONFIG);
                    analytics = getAnalytics(app);
                    // Enable auto collection
                    analytics.app.automaticDataCollectionEnabled = true;
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    console.error("Firebase init error", error);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }));
};
export var enableWindowOnError = function() {
    var product = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).product;
    if (process.env.PRODUCT_NAME !== product) return null;
    window.onerror = function(message, source, lineno, colno, error) {
        if (error) message = error.stack;
        if (message.includes("defined") || message.includes("ReferenceError")) {
            trace({
                message: message,
                lineno: lineno,
                colno: colno,
                error: error,
                userAgent: navigator.userAgent
            });
        }
    };
};
export var getChannelLogo = function() {
    var _ref = _async_to_generator(function(url) {
        var isCentered, svgString, response, e;
        var _arguments = arguments;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    isCentered = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
                    svgString = DEFAULT_CHANNEL_LOGO[isCentered ? "center" : "left"];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        request({
                            method: "get",
                            url: url,
                            contentType: "image/svg+xml"
                        })
                    ];
                case 2:
                    response = _state.sent();
                    if (!response.toLowerCase().includes("doctype")) {
                        svgString = response;
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2,
                        svgString
                    ];
            }
        });
    });
    return function getChannelLogo(url) {
        return _ref.apply(this, arguments);
    };
}();
export var loadScriptByURL = function(id, url, callback) {
    var isScriptExist = document.getElementById(id);
    if (!isScriptExist) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        script.id = id;
        script.onload = function() {
            if (callback) callback();
        };
        document.body.appendChild(script);
    }
    if (isScriptExist && callback) callback();
};
export var changeWebSetting = function(profileSettings, newSetting) {
    return _object_spread_props(_object_spread({}, profileSettings), {
        web_settings: _object_spread({}, profileSettings.web_settings, newSetting)
    });
};
export var findDeviceSettingsItem = function(deviceSettingsList, id) {
    return deviceSettingsList.find(function(e) {
        return e.channelInfo.id === id;
    });
};
export var findDeviceSettingsItemIndex = function(deviceSettingsList, id) {
    return deviceSettingsList.findIndex(function(e) {
        return e.channelInfo.id === id;
    });
};
export var sha256 = function() {
    var _ref = _async_to_generator(function(source) {
        var sourceBytes, digest, resultBytes;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    sourceBytes = new TextEncoder().encode(source);
                    return [
                        4,
                        crypto.subtle.digest("SHA-256", sourceBytes)
                    ];
                case 1:
                    digest = _state.sent();
                    resultBytes = _to_consumable_array(new Uint8Array(digest));
                    return [
                        2,
                        resultBytes.map(function(x) {
                            return x.toString(16).padStart(2, "0");
                        }).join("")
                    ];
            }
        });
    });
    return function sha256(source) {
        return _ref.apply(this, arguments);
    };
}();
export var convertToDeviceSettingsItemList = function(channelList, DeviceSettingsItemList) {
    return channelList.map(function(item, index) {
        var deviceSettingsItem = DeviceSettingsItemList.find(function(e) {
            return e.channelInfo.id === item.id;
        });
        var currentLockState = deviceSettingsItem && deviceSettingsItem.channelSettings.locked;
        var lockedModified = currentLockState !== undefined && item.locked !== currentLockState;
        return {
            channelInfo: _object_spread({
                // Default values
                name: item.name,
                id: item.id
            }, deviceSettingsItem && deviceSettingsItem.channelInfo),
            channelSettings: _object_spread_props(_object_spread({
                // Default values
                favoritePosition: 1,
                timeshift: false,
                visible: true,
                audio: null,
                // audioIsChangedByUser: false,
                resolution: null,
                // resolutionIsChangedByUser: false,
                subtitles: null
            }, deviceSettingsItem && deviceSettingsItem.channelSettings), {
                // Update position index
                position: index + 1,
                // Update lockedModified
                lockedModified: lockedModified,
                locked: lockedModified ? currentLockState : item.locked
            })
        };
    });
};
export var checkVisibleStatusForChannel = function(profileSettings, id) {
    if (!profileSettings) {
        return true;
    }
    var channelItem = findDeviceSettingsItem(profileSettings.web_settings.DeviceSettingsItemList, id);
    return channelItem ? channelItem.channelSettings.visible : true;
};
/**
 * @param {*} profileSettings
 * @param {*} id
 * @returns {Boolean}
 * true - if channel is currently locked
 * false - if channel is is currently unlocked or not locked at all
 */ export var checkLockStatusForChannel = function(profileSettings, id) {
    if (!profileSettings) {
        return false;
    }
    var channelItem = findDeviceSettingsItem(profileSettings.web_settings.DeviceSettingsItemList, id);
    var lockPeriod = profileSettings.web_settings.lockPeriod;
    var isSessionStorage = lockPeriod === LOCK_PERIODS.SESSION_LOCK;
    var timeToLockChannels = getSessionLockTime(isSessionStorage);
    var expired = (timeToLockChannels || 0) < Date.now();
    var channelLocked = channelItem === null || channelItem === void 0 ? void 0 : channelItem.channelSettings.locked;
    return channelLocked && expired;
};
export var resolveObject = function(path, obj) {
    return path.split(".").reduce(function(prev, curr) {
        return prev ? prev[curr] : null;
    }, obj || self);
};
export var diffObjects = function(object1, object2) {
    var keys = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            var prev = resolveObject(key, object1);
            var current = resolveObject(key, object2);
            if (!isEqual(prev, current)) {
                return true;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
};
export var deepMergeFlatten = function(obj1, obj2) {
    var keys = Object.keys(obj2);
    var nextObj = _object_spread({}, obj1);
    for(var i = 0; i < keys.length; i += 1){
        var key = keys[i];
        var value = obj2[key];
        if (typeof value === "object" && value !== null) {
            nextObj = _object_spread({}, nextObj, deepMergeFlatten(nextObj, value));
        } else {
            nextObj = _object_spread_props(_object_spread({}, nextObj), _define_property({}, key, value));
        }
    }
    return nextObj;
};
export var convertLanguages = function() {
    var languages = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], fromFormat = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "3", toFormat = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "2B";
    // return languages.map((language) => {
    //   return availableLanguages.find(e => e[fromFormat] === language)[toFormat]
    // })
    var mappedLanguages = [];
    languages.forEach(function(language) {
        var foundLanguage = availableLanguages.find(function(e) {
            return e[fromFormat] === language;
        });
        foundLanguage && mappedLanguages.push(foundLanguage[toFormat]);
    });
    return mappedLanguages;
};
/**
 * Object.entriesFrom() polyfill
 * @author Chris Ferdinandi
 * @license MIT
 */ if (!Object.fromEntries) {
    Object.fromEntries = function(entries) {
        if (!entries || !entries[Symbol.iterator]) {
            throw new Error("Object.fromEntries() requires a single iterable argument");
        }
        var obj = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = _sliced_to_array(_step.value, 2), key = _step_value[0], value = _step_value[1];
                obj[key] = value;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return obj;
    };
}
/**
 * https://gist.github.com/addyosmani/d5648c89420eb333904c
 */ if (![].fill) {
    Array.prototype.fill = function(value) {
        var O = Object(this);
        var len = Number.parseInt(O.length, 10);
        var start = arguments[1];
        var relativeStart = Number.parseInt(start, 10) || 0;
        var k = relativeStart < 0 ? Math.max(len + relativeStart, 0) : Math.min(relativeStart, len);
        var end = arguments[2];
        var relativeEnd = end === undefined ? len : Number.parseInt(end) || 0;
        var final = relativeEnd < 0 ? Math.max(len + relativeEnd, 0) : Math.min(relativeEnd, len);
        for(; k < final; k++){
            O[k] = value;
        }
        return O;
    };
}
// HACK: This is a hack to attach a button to the Chargebee container
// to close the Chargebee modal on mobile devices
export var attachChargebeeButton = function(text, onClick) {
    if (document.getElementById("chargebee-button")) return;
    var customElement = document.createElement("div");
    customElement.id = "chargebee-button";
    customElement.style = "\n    position: absolute;\n    bottom: 67px;\n    z-index: 1000000;\n    width: 100%;\n    padding: 16px;\n    display: flex;\n    justify-content: center;\n  ";
    customElement.innerHTML = '\n    <button class="MuiButtonBase-root-191 MuiButton-root-229 MuiButton-text-231 MuiButton-flat-234 button raised half-width pointer cb-button" tabindex="0" type="button">\n      <span class="MuiButton-label-230 ux-button-label">'.concat(text, '</span>\n      <span class="MuiTouchRipple-root-255"></span>\n    </button>\n  ');
    customElement.addEventListener("pointerup", onClick);
    var cbContainer = document.getElementById("cb-container");
    cbContainer.appendChild(customElement);
};
export var removeChargebeeButton = function() {
    var customElement = document.getElementById("chargebee-button");
    if (customElement) {
        customElement.remove();
    }
};
export var getBoxType = function(box) {
    var _box_id;
    var splitString = box === null || box === void 0 ? void 0 : (_box_id = box.id) === null || _box_id === void 0 ? void 0 : _box_id.split("-");
    splitString.pop();
    var stringNoDiscount = splitString.join("-");
    return TV_BOX_ID_TO_TYPE_MAP[stringNoDiscount];
};
export var getPercentDiff = function(a, b) {
    var min = Math.min(a, b);
    var max = Math.max(a, b);
    return (max - min) / max;
};
// Helper for getting the price of an addon or subscription
export var getItemPrice = function(billingData, cmsData, currencyConversion) {
    var forceEuro = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var price = billingData.price, currencyCode = billingData.currencyCode;
    var promo_price = cmsData.promo_price, original_price = cmsData.original_price;
    var originalPrice;
    var discountedPrice;
    var usingCMSPrice = !isNil(original_price);
    var convertedBillingPrice = convertCurrency(price, currencyCode, currencyConversion);
    originalPrice = usingCMSPrice ? original_price : convertedBillingPrice.value;
    var hasCMSPromoPrice = !isNil(promo_price);
    var usingCMSPromoPrice = hasCMSPromoPrice || usingCMSPrice;
    discountedPrice = hasCMSPromoPrice ? promo_price : originalPrice;
    var hasPromoPrice = !isNil(discountedPrice) && getPercentDiff(discountedPrice, originalPrice) > MAX_PRICE_PERCENT_DIFFERENCE;
    if (forceEuro) {
        if ((currencyConversion === null || currencyConversion === void 0 ? void 0 : currencyConversion.currency) === 'BGN') {
            originalPrice = Math.round(originalPrice / (currencyConversion === null || currencyConversion === void 0 ? void 0 : currencyConversion.conversion_rate));
            discountedPrice = hasCMSPromoPrice ? Math.round(promo_price / (currencyConversion === null || currencyConversion === void 0 ? void 0 : currencyConversion.conversion_rate)) : originalPrice;
        }
    }
    return {
        originalPrice: originalPrice,
        discountedPrice: discountedPrice,
        hasPromoPrice: hasPromoPrice,
        isFromCMS: {
            original: usingCMSPrice,
            promo: usingCMSPromoPrice
        },
        currencyCode: convertedBillingPrice.currency
    };
};
/**
 * Returns a hash code from a string
 * @param  {String} str The string to hash.
 * @return {Number}    A 32bit integer
 * @see https://stackoverflow.com/questions/6122571/simple-non-secure-hash-function-for-javascript
 */ export function hashCode(str) {
    var hash = 0;
    for(var i = 0, len = str.length; i < len; i++){
        var chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
}
export function pipe() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++){
        fns[_key] = arguments[_key];
    }
    return function(arg) {
        return fns.reduce(function(acc, fn) {
            return fn(acc);
        }, arg);
    };
}
export function hexColorAlpha(color, alpha) {
    if (!color) return color;
    var hexColor = color.replace("#", "").slice(0, 6);
    var alphaHex = padStart(Math.round(alpha * 255).toString(16), 2, "0");
    return "#".concat(hexColor).concat(alphaHex);
}
export function getContextValue(context, variable) {
    if (variable.type === CONTEXT_MATCH_TYPES.POINTER) {
        try {
            return pointer.get(context, variable.value);
        } catch (e) {
            return null;
        }
    }
    if (variable.type === CONTEXT_MATCH_TYPES.EMPTY) {
        return null;
    }
    if (variable.type === CONTEXT_MATCH_TYPES.VALUE) {
        return variable.value;
    }
    throw new Error("Invalid context match variable type: ".concat(variable.type));
}
export function contextMatchAction(context, param) {
    var _param = _sliced_to_array(param, 3), action = _param[0], a = _param[1], b = _param[2];
    var aValue = getContextValue(context, a);
    var bValue = getContextValue(context, b);
    var hasEmptyValue = a.type === CONTEXT_MATCH_TYPES.EMPTY || b.type === CONTEXT_MATCH_TYPES.EMPTY;
    var valuesMatch = isEqualWith(aValue, bValue, hasEmptyValue ? isEmpty : undefined);
    return valuesMatch ? action : null;
}
export function contextMatch(context, match) {
    var actions = match.map(function(action) {
        return contextMatchAction(context, action);
    }).filter(Boolean);
    return actions[actions.length - 1] || null;
}
export function getLineHeightPx(element) {
    var computedStyle = window.getComputedStyle(element);
    var lineHeight = computedStyle.getPropertyValue("line-height");
    if (lineHeight === "normal") {
        var fontSize = computedStyle.getPropertyValue("font-size");
        return Number.parseFloat(fontSize) * 1.2;
    }
    return Number.parseFloat(lineHeight);
}
export function isBillingValid(billingData) {
    // First check if billingData exists at all
    if (isEmpty(billingData)) return false;
    var isFieldValid = function(value, pattern) {
        if (!value) return false;
        var cleanValue = value.replace(/\s/g, "");
        return cleanValue.length > 0 && !pattern.test(cleanValue);
    };
    if (!isFieldValid(billingData[FIRST_NAME_INPUT], REGEX_ALPHABET)) return false;
    if (!isFieldValid(billingData[LAST_NAME_INPUT], REGEX_ALPHABET)) return false;
    if (!isFieldValid(billingData[PHONE_INPUT], REGEX_PHONE)) return false;
    if (!isFieldValid(billingData[COUNTRY_DROPDOWN], REGEX_ALPHANUMERIC)) return false;
    return true;
}
